__turbopack_context__.v({
  "root": "checkbox-list-module-scss-module__Lep1-W__root",
});
